import clsx from 'clsx';
import React from 'react';
import { SetupGuideDocs } from '../../../../docs/components/setup-guide-docs/SetupGuideDocs';
import { HdButton, HdIcon } from '../../../../components';
import styles from './AdsAccountError.module.scss';

export interface AdsAccountErrorProps {
  accountType: string;
  docLink: string;
  accountEmail: string;
  onTryAgainClick: () => void;
  onInviteMemberClick: () => void;
}
export function AdsAccountError({
  accountType,
  docLink,
  accountEmail,
  onTryAgainClick,
  onInviteMemberClick
}: AdsAccountErrorProps) {
  return (
    <div className='d-flex h-100' data-id='ads-account-error'>
      <div className='d-flex justify-center bg-surface flex-1'>
        <div className={clsx(styles.connectorContainer, 'py-5 px-7')}>
          <div className={clsx(styles.noItemBox, 'no-item-box errored')}>
            <div className={clsx('no-item-box-icon-container')}>
              <HdIcon name='error-filled' className='no-item-box-icon' />
            </div>

            <div className='no-item-box-content'>
              <span className='no-item-box-title'>No {accountType} Account Found</span>

              <span className='no-item-box-desc'>
                Hey, you don't seem to have any valid {accountType} account associated with account{' '}
                {accountEmail}. You can try logging in with a different account which has access or
                ask a team member to get access to your data.
              </span>
            </div>

            <div className='form-buttons pt-0 mt-7'>
              <HdButton variation='outline' onClick={() => onTryAgainClick()} dataId='ads-account-error-try-again'>
                Try Again
              </HdButton>

              <HdButton dataId='ads-account-invite-member' onClick={() => onInviteMemberClick()}>Invite a Team Member</HdButton>
            </div>
          </div>
        </div>
      </div>

      {docLink && (
        <div className={styles.setupGuideDocs}>
          <SetupGuideDocs
            docLink={docLink}
            areTabsRendered={false}
            loadingParent={false}
            autoScrollToSectionOnLoad
            scrollToSectionProps={{
              sourceSection: 'source-account-settings',
              label: 'account-error'
            }}
          />
        </div>
      )}
    </div>
  );
}
